<template lang="pug">

  form-group-row(:form="form", :label="label", name="email_confirmation", required)
    form-input(:form="form", name="email_confirmation", type="email")

</template>

<script>

export default {
  name: 'user-input-email-confirmation',

  props: {
    label: {
      type: String,
      default: 'Email confirmation',
    }
  },

  data: () => ({
    form: null,
  }),

  async created() {
    this.form = this.$parent.form;
    this.form.email_confirmation = this.$parent.user ? this.$parent.user.email_confirmation : '';
  },
}

</script>
